<template>
    <b-row>
        <b-col cols="12">
            <h4 class="mb-3">
                Datos del comprador
            </h4>
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <FormInput
                v-model="comprador.name"
                id="nombre"
                rules="required"
                :label="$t('formularios.nombre')"
                :name="$t('formularios.nombre')"
            />
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <FormInput
                v-model="comprador.lastName"
                rules="required"
                id="lastName"
                :label="$t('formularios.apellidos')"
                :name="$t('formularios.apellidos')"
            />
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <FormInput
                v-model="comprador.email"
                rules="required"
                vid="confirmation'"
                id="email'"
                type="email"
                :label="$t('formularios.email')"
                :name="$t('formularios.email')"
            />
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <FormInput
                v-model="comprador.email_confirm"
                id="email-confirm"
                type="email"
                :rules="{ required: true, confirmed_ci: { target: comprador.email } }"
                :label="$t('formularios.confirmar_email')"
                :name="$t('formularios.confirmar_email')"
            />
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <DocumentoTipo
                :value="comprador.identification.type"
                @input="val => { comprador.identification.type = val; }"
            />
        </b-col>
        <b-col cols="12" md="6" lg="4">
            <DocumentoValor
                :type="comprador.identification.type"
                :value="comprador.identification.value"
                @input="val => { comprador.identification.value = val; }"
            />
        </b-col>
        <b-col cols="12" class="m-3">
            <hr/>
        </b-col>
    </b-row>
</template>

<script>
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        name: "DatosAbonoSGAComponent",
        props: {
            datos_comprador: {
                type: Object,
                required: true
            }
        },
        computed: {
            comprador: {
                get() {
                    return this.datos_comprador;
                },
                set(value) {
                    this.$emit('update:datos_comprador', value);
                }
            },
        },
        components: {
            DocumentoTipo,
            DocumentoValor
        },
    }
</script>